<ng-container *transloco="let t">
	<div class="flex flex-col">
		<vis-ods-icon-button-component
			name="backArrow"
			class="pb-m block"
			(click)="navigateBack()"
		></vis-ods-icon-button-component>
		<div class="flex flex-col" *ngIf="settings()?.direct_shipment; else B2CNotSupported">
			<beyond-online-headline
				[headline]="t('generalComponents.addressSelector.headlines.title')"
				size="l"
				class="mb-m"
			></beyond-online-headline>
			<beyond-online-tab-group>
				<beyond-online-tab-navigation
					[active]="isB2BShipment()"
					class="mt-m"
					[label]="t('generalComponents.addressSelector.texts.storeAddress')"
				>
					<app-store-selector
						[storesLoading]="storesLoading()"
						[stores]="stores()"
						[selectedStore]="selectedShipToStore()"
						(storeSelected)="onStoreSelected($event)"
						[config]="{ hideBackButton: true }"
					></app-store-selector>
				</beyond-online-tab-navigation>
				<beyond-online-tab-navigation
					[label]="t('generalComponents.addressSelector.texts.customerAddress')"
					[active]="!isB2BShipment()"
				>
					<app-customer-address
						[initialShipToAddress]="isB2BShipment() ? undefined : selectedShipToStore()"
						(addressChanged)="onCustomerAddressChanged($event)"
						(cancel)="navigateBack()"
					></app-customer-address>
				</beyond-online-tab-navigation>
			</beyond-online-tab-group>
		</div>
		<ng-template #B2CNotSupported>
			<app-store-selector
				[storesLoading]="storesLoading()"
				[stores]="stores()"
				[selectedStore]="selectedShipToStore()"
				(storeSelected)="onStoreSelected($event)"
				[config]="{ hideBackButton: true }"
			></app-store-selector>
		</ng-template>
	</div>
</ng-container>
